import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { IBreadCrumb } from './breadcrumb.interface';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent implements OnInit {
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  private breadcrumbService = inject(BreadcrumbService);

  private routeBreadcrumbs = signal<IBreadCrumb[]>([]);
  breadcrumbs = computed(() => this.breadcrumbService.applyLabels(this.routeBreadcrumbs()));

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const breadcrumbs: IBreadCrumb[] = [];
      this.buildBreadcrumb(this.activatedRoute.root, breadcrumbs);
      this.routeBreadcrumbs.set(breadcrumbs);
    });
  }

  private buildBreadcrumb(route: ActivatedRoute, breadcrumbs: IBreadCrumb[], url: string = '') {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return;
    }

    for (const child of children) {
      if (child.outlet !== 'primary') {
        continue;
      }

      if (!child.routeConfig || child.routeConfig.path == null) {
        this.buildBreadcrumb(child, breadcrumbs, url);
        return;
      }

      const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const routeConfig = child.routeConfig;
      let label = '';

      if (child.snapshot.title) {
        label = child.snapshot.title;
      } else if (routeConfig.title) {
        label = typeof routeConfig.title === 'string' ? routeConfig.title : '';
      }

      if (label) {
        breadcrumbs.push({
          label: label,
          url: url,
        });
      }

      this.buildBreadcrumb(child, breadcrumbs, url);
    }
  }
}
